import PropTypes from 'prop-types';
import { MentionsInput, Mention } from 'react-mentions';
import htmlToMarkdown from './htmlToMarkdown';
import FormattingHint from './FormattingHint';
import Avatar from '../../ui_elements/avatar/Avatar';
import { FlexRow } from '../../containers/flexbox_layout/FlexboxGrid';
import { A } from '../../base';

const Mentions = (props) => {
  const { value, rows, name, users, style, onMentionAdd } = props;
  const { showFormattingHint, ...inputProps } = props;

  // react-mentions owns paste (document listener, markup-aware splice); this only upgrades
  // the payload from stripped plain text to markdown, and yields to it on anything unexpected.
  const handlePaste = (event) => {
    const clipboard = event.clipboardData;
    if (!clipboard) return;

    const markdown = htmlToMarkdown(clipboard.getData('text/html'));
    if (!markdown || markdown === clipboard.getData('text/plain')) return;
    if (!document.queryCommandSupported || !document.queryCommandSupported('insertText')) return;

    event.preventDefault();
    event.stopPropagation();
    document.execCommand('insertText', false, markdown);
  };

  const handleAdd = (id, display) => {
    if (onMentionAdd) {
      onMentionAdd(id, display);
    }
  };

  return (
    <>
      <MentionsInput
        {...inputProps}
        value={value}
        style={style}
        rows={rows}
        name={name}
        id={name}
        outdated="false"
        resize="false"
        autoFocus={true}
        data-testid="new-comment-form"
        onPaste={handlePaste}
      >
        <Mention
          markup="**__display__**"
          trigger="@"
          data={users}
          onAdd={handleAdd}
          renderSuggestion={(highlightedDisplay, focused) => {
            return (
              <FlexRow
                className={`user ${focused ? 'focused' : ''}`}
                style={{ alignItems: 'center' }}
              >
                <Avatar
                  src={highlightedDisplay.avatar}
                  alt={highlightedDisplay.display}
                  position="relative"
                />
                <A title="avatar-display" style={{ marginLeft: '15px' }}>
                  {highlightedDisplay.display}
                </A>
              </FlexRow>
            );
          }}
          style={{ backgroundColor: '#d4eaf4' }}
        />
      </MentionsInput>
      {showFormattingHint ? <FormattingHint /> : null}
    </>
  );
};

const userShape = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  display: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
};

Mentions.propTypes = {
  value: PropTypes.string,
  users: PropTypes.arrayOf(PropTypes.shape(userShape)),
  rows: PropTypes.number,
  name: PropTypes.string,
  style: PropTypes.object,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMentionAdd: PropTypes.func,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  resize: PropTypes.bool,
  outdated: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  showFormattingHint: PropTypes.bool,
};

Mentions.defaultProps = {
  value: '',
  rows: 7,
  users: [],
  name: '',
  onChange: undefined,
  onKeyDown: undefined,
  onMentionAdd: undefined,
  placeholder: '',
  autoFocus: true,
  resize: false,
  outdated: false,
  showFormattingHint: false,
};

export default Mentions;
